import { en } from './en';
import { fr } from './fr';

export type Language = 'en' | 'fr';

type Section =
  | 'landing'
  | 'header'
  | 'footer'
  | 'nav'
  | 'profile'
  | 'plans'
  | 'billing'
  | 'home'
  | 'modules'
  | 'clients'
  | 'groups'
  | 'templates'
  | 'api'
  | 'imminote'
  | 'sdk'
  | 'botFlows'
  | 'users'
  | 'modals'
  | 'common'
  | 'refresh'
  | 'demos'
  | 'faq'
  | 'privacy'
  | 'terms'
  | 'subscriptionBanner'
  | 'export'
  | 'erasure'
  | 'rakine'
  | 'whatchat'
  | 'pricing'
  | 'admin'
  | 'optIn';

export type LanguageMessage = {
  [key in Section]: {
    [key: string]: any;
  };
};

export type Message = {
  [key in Language]: LanguageMessage;
};

export const messagesByLanguage: Message = {
  en,
  fr,
};

// Auth0 locale codes (BCP 47 format)
export const auth0Locales: Record<Language, string> = {
  en: 'en',
  fr: 'fr-FR',
};
